// Admin v2 — keret: fix oldalsáv + tartalom (Figma: 256 px sáv, 40 px oldalmargó, 32 px felső térköz).
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import AdminSidebar from './AdminSidebar';
import { Icon } from './icons';
import { ToastProvider } from './ui';
import { ClubProvider } from './club/clubData';

export default function AdminLayout() {
  const { user } = useAuth();
  const loc = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [me, setMe] = useState<{ username: string; avatarUrl: string | null }>({ username: '', avatarUrl: null });

  useEffect(() => {
    if (!user) return;
    return onSnapshot(doc(db, 'users', user.uid), (s) => {
      const v = s.data() ?? {};
      setMe({
        username: (v.username as string) || (v.displayName as string) || user.displayName || '',
        avatarUrl: (v.avatarUrl as string) || (v.photoURL as string) || null,
      });
    }, () => undefined);
  }, [user]);

  // lapváltáskor a tartalom tetejére ugrunk
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);

  return (
    <ToastProvider>
      <ClubProvider>
      <div className="min-h-screen bg-[#010306] text-white">
        <button
          type="button"
          onClick={() => setMobileOpen((o) => !o)}
          className="lg:hidden fixed top-4 left-4 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-[#0b0f14] border border-[#31383D] text-white"
          aria-label="Menü"
        >
          <Icon name={mobileOpen ? 'X' : 'List'} size={22} />
        </button>
        {mobileOpen && <div className="lg:hidden fixed inset-0 z-30 bg-black/60" onClick={() => setMobileOpen(false)} />}

        <AdminSidebar
          username={me.username}
          avatarUrl={me.avatarUrl}
          mobileOpen={mobileOpen}
          onNavigate={() => setMobileOpen(false)}
        />

        <main className="lg:ml-64 px-4 sm:px-6 lg:px-10 pt-20 lg:pt-8 pb-12 overflow-x-hidden">
          <div className="max-w-[1400px] mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
      </ClubProvider>
    </ToastProvider>
  );
}
